import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast tm-toast group-[.toaster]:!bg-[#4A3628] group-[.toaster]:!text-[#F3F7F2] group-[.toaster]:!border-0 group-[.toaster]:!rounded-full group-[.toaster]:!shadow-none group-[.toaster]:!px-5",
          title: "group-[.toast]:font-semibold",
          icon: "group-[.toast]:hidden",
          description: "group-[.toast]:!text-[#A9B8A5]",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
